module.exports = __webpack_public_path__ + "static/media/code-24px.950183b6.svg";